import { render, staticRenderFns } from "./InteresTasaForm.vue?vue&type=template&id=cb456e56&scoped=true"
import script from "./InteresTasaForm.vue?vue&type=script&lang=js"
export * from "./InteresTasaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb456e56",
  null
  
)

export default component.exports